import React from "react";

import DropPopup from "../../../../../components/DropPopup";
import { SettingsInput } from "../../../../../components/inputs/SettingsInput";
import { SettingsConfirmModal } from "../../../../../components/modal/SettingsConfirmModal";
import { Button } from "../../../../../components/newUI/button";
import { WarningExclaimSvg } from "../../../../../components/svg/WarningExclaimSvg";
import {
  TaskTemplatesConfirmModalsProps,
  TaskTemplatesDuplicateModalProps,
  TaskTemplatesImportModalProps,
} from "../model/taskTemplatesList.types";
import { TemplateDeleteConfirm } from "./TemplateDeleteConfirm";

export const TaskTemplatesConfirmModals: React.FC<
  TaskTemplatesConfirmModalsProps
> = ({
  deleteTemplate,
  deactivateTemplate,
  activateTemplate,
  isDeleting,
  isDeactivating,
  isActivating,
  onCloseDelete,
  onCloseDeactivate,
  onCloseActivate,
  onConfirmDelete,
  onConfirmDeactivate,
  onConfirmActivate,
}) => (
  <>
    {deleteTemplate && (
      <TemplateDeleteConfirm
        templateId={deleteTemplate.id}
        templateName={deleteTemplate.templateName}
        isDeleting={isDeleting}
        onClose={onCloseDelete}
        onConfirm={onConfirmDelete}
      />
    )}

    {deactivateTemplate && (
      <SettingsConfirmModal
        onClose={onCloseDeactivate}
        onConfirm={onConfirmDeactivate}
        isLoading={isDeactivating}
        icon={<WarningExclaimSvg sizeCx={"h-6 w-6"} />}
        title={`Deactivate ‘${deactivateTemplate.templateName}’ template?`}
        description={
          "Are you sure you want to deactivate this template? You can reactivate it at any time."
        }
        confirmText={"Deactivate"}
        variant={"warning"}
      />
    )}

    {activateTemplate && (
      <SettingsConfirmModal
        onClose={onCloseActivate}
        onConfirm={onConfirmActivate}
        isLoading={isActivating}
        icon={<WarningExclaimSvg sizeCx={"h-6 w-6"} />}
        title={`Activate ‘${activateTemplate.templateName}’ template?`}
        description={
          "Are you sure you want to Activate this template? You can deactivate it at any time."
        }
        confirmText={"Activate"}
        variant={"warning"}
      />
    )}
  </>
);

export const TaskTemplatesImportModal: React.FC<
  TaskTemplatesImportModalProps
> = ({ isOpen, onClose, onFileDrop }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <DropPopup
      message={
        "If a task column has different names, it will be split into different templates"
      }
      title={"Import template"}
      close={onClose}
      onFileDrop={onFileDrop}
    />
  );
};

export const TaskTemplatesDuplicateModal: React.FC<
  TaskTemplatesDuplicateModalProps
> = ({
  isOpen,
  templateName,
  isDuplicating,
  onTemplateNameChange,
  onClose,
  onConfirm,
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className={"modal modal-open"}>
      <div className={"modal-box w-[400px] p-0"}>
        <div
          className={
            "border-b border-gray-200 px-3 py-2 text-[18px] font-semibold"
          }>
          Copy Template
        </div>

        <div className={"flex flex-col gap-1 px-3"}>
          <div className={"mt-2 text-[16px]"}>Template Name</div>
          <SettingsInput
            value={templateName}
            onChange={(event) => onTemplateNameChange(event.target.value)}
            inputClasses={"h-[32px] text-[14px]"}
          />
        </div>

        <div className={"mx-4 my-3 flex justify-end gap-2"}>
          <Button
            type={"button"}
            autoWidth
            disabled={!templateName.trim() || isDuplicating}
            onClick={onConfirm}
            className={
              "h-[32px] w-[100px] border-[#7c66f0] bg-[#7c66f0] px-4 py-2 text-[14px] text-white hover:border-[#7c66f0] hover:bg-[#7c66f0] disabled:opacity-75"
            }>
            Copy
          </Button>

          <Button
            type={"button"}
            variant={"outline"}
            autoWidth
            disabled={isDuplicating}
            onClick={onClose}
            className={
              "h-[32px] w-[100px] border-[#C8D2DE] px-4 py-2 text-[14px] text-[#253747] hover:border-[#C8D2DE] hover:bg-white disabled:opacity-75"
            }>
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};
